export type RegistrationTextKey =
  | 'webappWelcomeButton'
  | 'webappPhoneSubtitle'
  | 'webappStoreSelectionTitle'
  | 'webappStoreSelectionLabel'
  | 'webappProfileTitle'
  | 'webappProfileSubtitle'
  | 'webappOptinTitle'
  | 'webappOptinSubtitle'
  | 'webappOptinYes'
  | 'webappOptinNo'

export type RegistrationStepId = 'reg-welcome' | 'reg-phone' | 'reg-store' | 'reg-profile' | 'reg-optin'

export const REGISTRATION_STEP_TEXTS: Record<RegistrationStepId, RegistrationTextKey[]> = {
  'reg-welcome': ['webappWelcomeButton'],
  'reg-phone': ['webappPhoneSubtitle'],
  'reg-store': ['webappStoreSelectionTitle', 'webappStoreSelectionLabel'],
  'reg-profile': ['webappProfileTitle', 'webappProfileSubtitle'],
  'reg-optin': ['webappOptinTitle', 'webappOptinSubtitle', 'webappOptinYes', 'webappOptinNo']
}
